import React from 'react';

const LoaderCircle = ({ leftMargin = true }) => {
  return (
    <div className={`spinner-border ${leftMargin ? 'ml-4' : ''} h-5 w-5`} role='status'>
      <span className='sr-only'>Loading...</span>
    </div>
  );
};

export default LoaderCircle;
